import { Controller } from 'stimulus';
import { t } from '../javascript/lib/i18n';

export default class extends Controller {
  static targets = [
    'input',
    'status',
    'smsButton',
    'callButton',
    'countryCode',
    'inputFields',
    'extension',
  ];

  static values = {
    invitationToken: String,
    organisationId: String,
  };

  connect() {
    const hasPhoneNumber = this.inputTarget.value.trim() !== '';
    const hasCountryCode =
      this.hasCountryCodeTarget && this.countryCodeTarget.value.trim() !== '';

    this.toggleButtons(hasPhoneNumber || hasCountryCode);
  }

  handleInput() {
    const hasPhoneNumber = this.inputTarget.value.trim() !== '';
    const hasCountryCode =
      this.hasCountryCodeTarget && this.countryCodeTarget.value.trim() !== '';

    this.toggleButtons(hasPhoneNumber || hasCountryCode);
  }

  toggleButtons(shouldShow) {
    const action = shouldShow ? 'remove' : 'add';
    const hasExtension =
      this.hasExtensionTarget && this.extensionTarget.value.trim() !== '';

    this.callButtonTarget.classList[action]('d-none');

    if (hasExtension) {
      this.smsButtonTarget.classList.add('d-none');
    } else {
      this.smsButtonTarget.classList[action]('d-none');
    }
  }

  validateNumber() {
    const phoneNumber = this.inputTarget.value.replace(/\s+/g, '');
    // This regex validates phone numbers in both international (+ followed by 2-15 digits)
    // and local formats (10-15 digits without a +).
    const phoneRegex = /^(?:\+?[0-9]\d{1,14}|\d{10,15})$/;
    const isValid = phoneRegex.test(phoneNumber);

    this.updateStatus(isValid);
    if (isValid) {
      this.updateButtons(phoneNumber);
    }
    return isValid;
  }

  validateSms(event) {
    event.preventDefault();
    this.clearStatusMessage();

    if (this.smsButtonTarget.dataset.url === '#' || !this.validateNumber()) {
      return;
    }

    this.postRequest(this.smsButtonTarget.dataset.url, 'sms');
  }

  validateCall(event) {
    event.preventDefault();
    this.clearStatusMessage();

    if (this.callButtonTarget.dataset.url === '#' || !this.validateNumber()) {
      return;
    }

    this.postRequest(this.callButtonTarget.dataset.url, 'call');
  }

  postRequest(url, medium) {
    fetch(url, {
      method: 'POST',
      headers: this.headers,
    })
      .then((response) => {
        if (response.ok) {
          this.handleResponse(medium);
        } else {
          this.handleError(
            t('js.test_phone_number.failed_to_verify', { medium })
          );
        }
        return response;
      })
      .catch((error) => {
        this.handleError(
          t('js.test_phone_number.verification_error', { medium, error })
        );
        throw error;
      });
  }

  handleResponse(medium) {
    if (medium === 'sms') {
      medium = 'SMS';
    } else {
      medium = medium.charAt(0).toUpperCase() + medium.slice(1);
    }
    this.statusTarget.innerHTML = t('js.test_phone_number.test_created', {
      medium,
    });
  }

  handleError(errorMessage) {
    console.error(errorMessage);
    this.statusTarget.innerHTML = errorMessage;
  }

  clearStatusMessage() {
    this.statusTarget.innerHTML = '';
  }

  updateStatus(isValid) {
    if (isValid) {
      this.inputTarget.classList.remove('is-invalid');
      this.inputTarget.classList.add('amba-phone-check-is-valid');
    } else {
      this.inputTarget.classList.remove('amba-phone-check-is-valid');
      this.inputTarget.classList.add('is-invalid');
    }
  }

  updateButtons(phoneNumber = this.inputTarget.value.replace(/\s+/g, '')) {
    const countryCode = this.hasCountryCodeTarget
      ? this.countryCodeTarget.value
      : '';
    const extension = this.hasExtensionTarget
      ? this.extensionTarget.value.trim()
      : '';

    let smsUrl = `/phone_number_tests?phone_prefix_country_code=${countryCode}&phone_number=${phoneNumber}&medium=sms`;
    let callUrl = `/phone_number_tests?phone_prefix_country_code=${countryCode}&phone_number=${phoneNumber}&medium=phone`;

    if (extension) {
      callUrl += `&phone_extension=${encodeURIComponent(extension)}`;
    }

    if (this.hasOrganisationIdValue && this.organisationIdValue) {
      smsUrl += `&organisation_id=${this.organisationIdValue}`;
      callUrl += `&organisation_id=${this.organisationIdValue}`;
    }

    if (this.hasInvitationTokenValue) {
      smsUrl += `&invitation_token=${this.invitationTokenValue}`;
      callUrl += `&invitation_token=${this.invitationTokenValue}`;
    }

    if (this.hasSmsButtonTarget) {
      this.smsButtonTarget.dataset.url = phoneNumber ? smsUrl : '#';
    }
    if (this.hasCallButtonTarget) {
      this.callButtonTarget.dataset.url = phoneNumber ? callUrl : '#';
    }
  }

  get headers() {
    return {
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')
        ?.content,
      'Content-type': 'application/json; charset=UTF-8',
    };
  }
}
